import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import Icon from "../Icon";
import { OUTCOMES } from "../../data/content";

export default function OutcomesSection() {
  return (
    <section className="ad-section bg-[#F7F8FA]" data-testid="outcomes-section">
      <div className="ad-container">
        <SectionHeading
          eyebrow="Business Outcomes"
          title={<>Technology is only valuable when it <span className="text-gradient">changes the business.</span></>}
        />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {OUTCOMES.map((o, i) => (
            <Reveal key={o.title} index={i % 4}>
              <div className="ad-card h-full p-8">
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#1677FF]/10 text-[#1677FF]">
                  <Icon name={o.icon} className="h-7 w-7" />
                </span>
                <h3 className="mt-6 text-lg font-bold text-[#111827]">{o.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#4B5563]">{o.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
